import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useLanguage } from "../language/LanguageContext"; // Import the language hook
import { ServerUrl } from "../config";

const Login = () => {
  const { t } = useLanguage(); // Use translation function from context
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const isDisabled = !email || !password;

  const handleLogin = async (e) => {
    e.preventDefault();

    const payload = {
      email: email,
      password: password,
    };

    try {
      const response = await fetch(`${ServerUrl}api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("email", data.email || email);
        localStorage.setItem("role", data.role || "user");
        localStorage.setItem("visibleTabs", JSON.stringify(data.visibleTabs || ["audio"]));
        localStorage.setItem("permissions", JSON.stringify(data.permissions || {
          canManageUsers: false,
          canUploadAudio: true,
          canUploadChannels: false,
          canUploadApps: false
        }));
        // Clear old user-specific data so stale email doesn't carry over between sessions
        const savedDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
        const cleanedDetails = { ...savedDetails, uploaderEmail: data.email || email };
        localStorage.setItem("userDetails", JSON.stringify(cleanedDetails));
        navigate("/audio");
      } else {
        setError(data.message || t("Login failed"));
        Swal.fire(t("Error"), data.message || t("Login failed"), "error");
      }
    } catch (err) {
      setError(t("Network error: ") + err.message);
      Swal.fire(t("Error"), err.message || t("Something went wrong"), "error");
    }
  };

  return (
    <div className="w-screen h-screen bg-gradient-to-r from-indigo-500 via-purple-600 to-pink-500 flex justify-center items-center p-4">
      <div className="bg-white p-6 sm:p-8 md:p-12 rounded-xl shadow-xl space-y-6 w-full lg:max-w-4xl xl:max-w-5xl">
        <h2 className="text-3xl font-semibold text-center text-gray-800 mb-6">{t("Login")}</h2>

        <form onSubmit={handleLogin} autoComplete="off">
          <div className="mb-4">
            <label htmlFor="email" className="block text-gray-700 text-sm font-medium mb-2">
              {t("Email")}
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="new-password"
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          <div className="mb-6">
            <label htmlFor="password" className="block text-gray-700 text-sm font-medium mb-2">
              {t("Password")}
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {error && <p className="text-red-500 text-sm text-center mb-4">{error}</p>}

          <button
            type="submit"
            disabled={isDisabled}
            className={`w-full py-3 font-semibold rounded-lg focus:outline-none focus:ring-2 ${
              isDisabled
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600 focus:ring-blue-400"
            }`}
          >
            {t("Login")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;